import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './TimePicker.module.scss';
import { Props } from './TimePicker.types';

/** @deprecated use `TimePickerInput` instead */
export const TimePicker = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        value={value || ''}
        onChange={event => onChange?.(event)}
        className={classnames(styles.timePicker, className)}
        type={'time'}
        {...props}
      />
    );
  }
);
